<template>
<div style="width: 85%; margin: auto; padding-top: 10px; color: #7b7c87">
    <v-layout row wrap>
      <v-flex
        xs12
        md12
        lg12
        xl12
        style="padding: 15px; padding-bottom: 2px !important"
      >
        <!--Row #1-->
        <v-layout row wrap>
          <v-flex
            xs12
            sm12
            md10
            lg10
            xl10
            style="padding: 15px; padding-bottom: 0px"
          >
            <div
              style="padding-top: 23px; font-weight: bolder; font-size: 20px"
            >
              مدیریت فروش ویژه
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
          <v-card>
              <v-card-text>
                  <v-data-table :items="BoxTableItems" :headers="BoxTableHeaders">
                      <template v-slot:[`item.type`]="{item}">
                          <v-chip v-if="item.type == 1" color="orange" dark>لیست محصولات</v-chip>
                      </template>
                      <template v-slot:[`item.link`]="{item}">
                          <v-icon small v-if="item.type == 2" @click="window.open(`${item.link}`)" color="blue" dark>fa fa-eye</v-icon>
                          <span v-else-if="item.type == 1"  light>---</span>
                          <span v-else-if="item.type == null"  light>تعریف نشده</span>
                      </template>
                      <template v-slot:[`item.operation`]="{item}">
                          <v-btn color="yellow darken-4" icon @click="SetBoxDetail(item)"><v-icon small>fa fa-cog</v-icon></v-btn>&nbsp;
                          <v-tooltip v-if="item.type == 1" top color="purple darken-4">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                text
                                icon
                                v-bind="attrs"
                                v-on="on"
                                small
                                color="purple darken-4"
                                @click="ShowBoxProducts(item.sectionId,item.id,item)"
                                ><v-icon small>fas fa-compress-arrows-alt</v-icon></v-btn
                                >
                            </template>
                            <span>لیست محصولات</span>
                          </v-tooltip>
                      </template>
                  </v-data-table>
              </v-card-text>
          </v-card>
      </v-flex>
      <template>
          <v-dialog fullscreen persistent v-model="SetBoxDetailDialog">
              <v-card>
                <v-card-title style="padding: 0px !important">
                    <v-app-bar dense color="rgb(42, 45, 69)" dark>
                    <v-toolbar-title style="color: orange">
                        <span>تنظیمات باکس</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon color="orange" @click="SetBoxDetailDialog = false" small
                        >fa fa-times</v-icon
                    >
                    </v-app-bar>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                            
                            <v-text-field
                            color="#2a2d45"
                            v-model="boxTitle"
                            outlined
                            dense
                            label="عنوان باکس "
                            ></v-text-field>
                            <v-color-picker  v-model="boxColor"></v-color-picker>
                            <div style="padding-top:10px">
                              <v-text-field
                            color="#2a2d45"
                            v-model="boxColor"
                            outlined
                            dense
                            label="رنگ "
                            ></v-text-field>
                            </div>
                            <v-text-field
                            v-if="boxType"
                            color="#2a2d45"
                            v-model="boxLink"
                            outlined
                            dense
                            label="لینک "
                            ></v-text-field>
                            <!-- <f-up :OldFile="boxImage" @RetunedFileName="boxImage = $event" Root="ELOGO" Folder="NONE" BtnTitle="لوگو"></f-up>  -->
                            <v-btn @click="SaveBoxDetail" outlined dark color="blue">
                              <v-icon small style="padding-left: 5px"
                                >fa fa-check</v-icon
                              >&nbsp; ذخیره
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm12 md8 lg8 xl8 style="padding:20px">
                            <seo-form FileLoc="PRDCATSEOIMG" :Seo="SeoData" @SeoData="SeoChanged"></seo-form>
                        </v-flex>
                    </v-layout>
                </v-card-text>
              </v-card>
          </v-dialog>
      </template>
      <template>
        <v-dialog fullscreen persistent v-model="SetBoxProductsDialog">
         <v-card>
         <v-card-title style="padding: 0px !important">
            <v-app-bar dense color="rgb(42, 45, 69)" dark>
              <v-toolbar-title style="color: orange">
                <span>محصولات </span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="orange" @click="SetBoxProductsDialog = false" small
                >fa fa-times</v-icon
              >
            </v-app-bar>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <div class="operationBoxDesign">
                <div
                  class="OperationBoxColumns"
                  v-for="i in MAXCATLEVELCOUNT"
                  :key="'catselectionholder' + i"
                >
                  <v-autocomplete
                    no-data-text="دسته بندی یافت نشد"
                    color="#2a2d45"
                    item-text="pC_Title"
                    item-value="pC_Id"
                    :items="FooterCategoryItems['cat' + i]"
                    @change="FooterCatSelectionChanged(i + 1, $event)"
                    :label="'دسته بندی سطح ' + i"
                    outlined
                    dense
                    v-model="FooterCategoryModel['cat' + i]"
                  ></v-autocomplete>
                </div>
              </div>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-text-field outlined v-model="SetProductsSearchByPName" dense label="نام محصول"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-text-field outlined dense v-model="SetProductsSearchByPCode" label="کد محصول"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-btn @click="loadProductsForSet(1)" outlined block color="rgb(42, 45, 69)"><v-icon small style="padding-left:5px">fa fa-search</v-icon>جستجو</v-btn>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <div class="d-flex justify-center align-center cpation font-weight-black">همه محصولات</div>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <v-data-table  :items-per-page="PageSizeSet" :items="SetAllProductTableItems" hide-default-footer :headers="MainTableHeader">
                  <template v-slot:[`item.operation`]="{item}">
                    <v-btn x-small @click="ShiftToSetTabl(item)" color="green accent-4"><v-icon color="#fff" x-small>fa fa-plus</v-icon></v-btn>
                  </template>
                </v-data-table>
                <v-row>
                  <v-col cols="10"><v-pagination @input="SetProdTableJumpToPage($event)" v-model="CurrentPageSet" color="orange" :length="PageCountsSet" total-visible></v-pagination></v-col>
                  <v-col cols="2"><v-select @change="loadProductsForSet(1)" label="تعداد آیتم در صفحه" :items="PageSizeItems" item-text="text" item-value="value" outlined dense v-model="PageSizeSet"></v-select></v-col>
                </v-row>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px" class="flex-row d-flex justify-sm-space-between">
                <v-row>
                  <v-col cols="3"><div class="d-flex justify-center align-center cpation font-weight-black">محصولات زیر مجموعه</div></v-col>
                  <v-col cols="6">
                    <v-row>
                      <v-col cols="4">
                        <v-edit-dialog @save="MSGHNDL.OK('بازه تاریخ با موفقیت تغییر یافت')">
                          <span>{{ConvertDateObjToStr(Dates)}}<v-icon style="padding-right:5px" color="blue" small>fa fa-edit</v-icon></span>
                          <template v-slot:input>
                            <v-card>
                              <v-card-text>
                                
                                <v-date-picker
                                
                                v-model="Dates"
                                locale="fa-IR"
                                range
                                selected-items-text=""
                                scrollable
                              >
                              
                              </v-date-picker>
                              </v-card-text>
                            </v-card>
                          </template>
                        </v-edit-dialog>
                      </v-col>
                      <v-col cols="4">
                        <v-edit-dialog @save="MSGHNDL.OK('ساعت با موفقیت تغییر یافت')">
                          <span>{{StartTime}}<v-icon style="padding-right:5px" color="blue" small>fa fa-edit</v-icon></span>
                          <template v-slot:input>
                            <v-card>
                              <v-card-text>
                                
                              <v-time-picker
                                v-model="StartTime"
                                :max="EndTime"
                                format="24hr"
                                full-width
                              >
                            
                              </v-time-picker>
                              
                              </v-card-text>
                            </v-card>
                          </template>
                        </v-edit-dialog>
                      </v-col>
                      <v-col cols="4">
                        <v-edit-dialog @save="MSGHNDL.OK('ساعت با موفقیت تغییر یافت')">
                          <span>{{EndTime}}<v-icon style="padding-right:5px" color="blue" small>fa fa-edit</v-icon></span>
                          <template v-slot:input>
                            <v-card>
                              <v-card-text>
                              
                              <v-time-picker
                                v-model="EndTime"
                                :min="StartTime"
                                format="24hr"
                                full-width
                              >
                            
                              </v-time-picker>
                              
                              </v-card-text>
                            </v-card>
                          </template>
                        </v-edit-dialog>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3"><v-btn outlined color="green" @click="SaveProductSet()"><v-icon small style="padding-left:5px">fa fa-check</v-icon>بروزرسانی</v-btn></v-col>
                </v-row>
                
                
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <v-data-table :items="SetTableItems" :headers="RelationTableHeader">
                  <template v-slot:[`item.operation`]="{item}">
                    <v-btn x-small @click="DeleteFromSetTable(item)" color="red accent-4"><v-icon color="#fff" x-small>fa fa-trash</v-icon></v-btn>
                  </template>
                  <template v-slot:[`item.disptitle`]="{item}">
                    <v-text-field outlined dense v-model="item.disptitle"></v-text-field>
                  </template>
                  <template v-slot:[`item.discount`]="{item}">
                    <v-row style="width:145px">
                      <v-col style="display: flex;justify-content: space-around;" cols="2"><v-btn @mouseleave="stop" @mouseup="stop" @touchend="stop" @touchcancel="stop" @mousedown="start(item)" @touchstart="start(item)" small icon><v-icon small>fa fa-plus</v-icon></v-btn></v-col>
                      <v-col cols="8">
                        <v-text-field flat full-width style="text-align:center;justify-content:center" v-model="item.discount" outlined dense></v-text-field>
                      </v-col>
                      <v-col style="display: flex;justify-content: space-around;" cols="2"><v-btn @click="(item.discount > 0)? item.discount--:item.discount = 0" small icon><v-icon small>fa fa-minus</v-icon></v-btn></v-col>
                    </v-row>
                  </template>
                  <template v-slot:[`item.discountype`]="{item}">
                      <v-row>
                          <v-col cols="4" style="display: flex;justify-content: flex-end;">
                              <v-switch v-model="item.discountype" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                          </v-col>
                     </v-row>

                  </template>

                  <!-- <template v-slot:[`item.sdate`]="{item}">
                    
                    
                   
                  </template>
                  <template v-slot:[`item.stime`]="{item}">
                    
                  </template>
                  <template v-slot:[`item.etime`]="{item}">
                    
                  </template> -->
                  <template v-slot:[`item.status`]="{item}">
                      <v-row>
                          <v-col cols="4" style="display: flex;justify-content: flex-end;">
                              <v-switch v-model="item.status" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                          </v-col>
                     </v-row>

                  </template>
                  <template v-slot:[`item.showInIndex`]="{item}">
                    <v-checkbox label="نمایش در صفحه اول" v-model="item.showInIndex"></v-checkbox>
                  </template>
                  
                </v-data-table>
              </v-flex>
            </v-layout>
            
          </v-card-text>
        </v-card>

        </v-dialog>
      </template>
    </v-layout>
</div>

</template>
<script>
const axios = require("axios");
const ApiUrl = require("../../constant/apiurl");
const MSGHNDL = require("../../constant/MessageHandler");
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JsonExcel from "vue-json-excel";

export default {
    name:"SpecialSale",
    components: {
    Loading,
    JsonExcel,
  },
    data:()=>({
    Dates:[],
    StartTime:"",
    EndTime:"",
    BoxID:0,
    SetProductDialog:false,
    SetProductsSearchByPName:"",
    SetProductsSearchByPCode:"",
    SetAllProductTableItems:[],
    SetTableItems:[],
    CurrentPageSet : 0,
    PageCountsSet: 0 ,
    PageSizeSet: 5,
    PageSizeItems:[
      {text:"5",value:5},
      {text:"10",value:10},
      {text:"20",value:20},
      {text:"40",value:40},
      {text:"100",value:100},
      {text:"200",value:200},
      {text:"500",value:500},
      {text:"5000",value:5000}
    ],
    RelationTableHeader: [
      { text: "محصول ", value: "title", sortable: true, align: "right" },
      { text: "عنوان نمایشی ", value: "disptitle", sortable: true, align: "right" },
      { text: "قیمت ", value: "price", sortable: true, align: "right" },
      { text: "نوع تخفیف ", value: "discountype", sortable: true, align: "right" },
      { text: " تخفیف  ", value: "discount", sortable: true, align: "right" },
      // { text: "بازه تاریخ", value: "sdate", sortable: true, align: "right" },
      // { text: "  از ساعت", value: "stime", sortable: true, align: "right" },
      // { text: "  تا ساعت", value: "etime", sortable: true, align: "right" },
      { text: "  وضعیت", value: "status", sortable: true, align: "right" },
      { text: "  نمایش در صفحه اول", value: "showInInex", sortable: true, align: "right" },
      { text: "عملیات ", value: "operation", sortable: true, align: "right" },
    ],
    MainTableHeader: [
      { text: "محصول ", value: "title", sortable: true, align: "right" },
      { text: "قیمت ", value: "price", sortable: true, align: "right" },
      { text: "عملیات ", value: "operation", sortable: true, align: "right" },
    ],
    BoxTableHeaders:[
        { text: "#", value: "counter", sortable: true, align: "right" },
        { text: "عنوان فروش ویژه", value: "title", sortable: true, align: "right" },
        { text: "عملیات", value: "operation", sortable: true, align: "right" },
    ],
    BoxTableItems:[
        {counter:1,title:" ",type:null,link:"",image:"",seo:"",sectionId:34,color:"#ffffff",id:0}
    ],
    SetBoxDetailDialog:false,
    boxId:"",
    boxTitle:"",
    boxType:false,
    boxLink:"",
    boxImage:"",
    uploadBoxImage:"",
    SeoData:{},
    seo:{},
    SetBoxProductsDialog:false,
    SetProductBoxId:0,
    SetProductsSearchByPName:"",
    SetProductsSearchByPCode:"",
    SetAllProductTableItems:[],
    interval:false,
    SelectedItem:{},
    sdateModal:false,
    stimemodal:false,
    etimemodal:false,
    boxColor:"",
    MAXCATLEVELCOUNT:0,
    FooterCategoryItems: {
      cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      cat5: [],
      cat6: [],
      cat7: [],
      cat8: [],
      cat9: [],
      cat10: [],
      cat11: [],
      cat12: [],
      cat13: [],
      cat14: [],
      cat15: [],
      cat16: [],
      cat17: [],
      cat18: [],
      cat19: [],
      cat20: [],
    },
    CategoryItems: {
      cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      cat5: [],
      cat6: [],
      cat7: [],
      cat8: [],
      cat9: [],
      cat10: [],
      cat11: [],
      cat12: [],
      cat13: [],
      cat14: [],
      cat15: [],
      cat16: [],
      cat17: [],
      cat18: [],
      cat19: [],
      cat20: [],
    },
FooterCategoryModel: [],
    CatId:0
    }),
    async created(){
        this.uploadBoxImage = ApiUrl.registerPcImg;
        await this.getAllowedMaxLevelCount();
        await this.LoadBoxs();
        await this.loadProductsForSet();
        
    },
    methods:{
      async FooterCatSelectionChanged(lvl, val) {
      let vm = this;
      if (lvl <= vm.MAXCATLEVELCOUNT) {
        let Model = {};
        Model.Id = val;
        let index = "cat" + lvl;
        await axios
          .post(ApiUrl.getCategoryChilds, Model)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              vm.$data["FooterCategoryItems"][index] = data.data.childs;
              console.warn("data:", data.data.childs);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        vm.CatId = val;
        console.warn("CATID" , val);
        await vm.loadProductsForSet();
      }
    },
      async getAllowedMaxLevelCount() {
      let vm = this;

      await axios
        .post(ApiUrl.getCategoiesOfLevelOne)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            vm.MAXCATLEVELCOUNT = data.data.max;
            for (let i = 1; i <= vm.MAXCATLEVELCOUNT; i++) {
              let index = `cat${i}`;
              vm.CategoryItems[index] = [];
              vm.FooterCategoryItems[index] = [];
            }
            vm.CategoryItems["cat1"] = data.data.cats;
            vm.FooterCategoryItems["cat1"] = data.data.cats;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
      ConvertDateObjToStr(dateObj)
      { 
        if(dateObj != ""  && typeof(dateObj) != typeof(undefined) && dateObj.length > 0)
        {
          return "از "+dateObj[0]+" تا "+dateObj[1];
        }
        else
        {
          return "تنظیم نشده";
        }
      },
    DeleteFromSetTable(item)
    {
      let vm = this;
      vm.SetTableItems.splice(vm.SetTableItems.indexOf(item),1);
    },
     async SaveProductSet() {
      let vm = this;
        let ArrObject = [];
        
        
        vm.SetTableItems.forEach((e) => {
          // alert(e.discountype);
          var Model = {};
          Model.BoxId = /*vm.SetProductBoxId*/vm.BoxID;
          Model.CombineId = e.id;
          Model.Title = e.disptitle;
          Model.Discount = e.discount;
          Model.DiscountType = e.discountype;
          Model.Start = vm.Dates[0]+" "+vm.StartTime+":00";
          Model.End = vm.Dates[1]+" "+vm.EndTime+":00";
          Model.StartTime = vm.StartTime;
          Model.EndTime = vm.EndTime;
          Model.DateDomain = vm.Dates.join(',');
          Model.Status = e.status;
          Model.ShowInIndex = e.showinindex;
          // Model.B_Id = vm.BoxID;
          ArrObject.push(Model);
        });
        await axios
          .post(ApiUrl.AddProductToBox+'/'+vm.BoxID, ArrObject)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              MSGHNDL.OK(data.msg);
              await vm.loadProductsForSet();
            }
            else
            {
              MSGHNDL.ERR(data.msg);
            }
          })
          .catch((err) => {
            console.error(err);
          });
    },

    stop(){
    	clearInterval(this.interval)
      this.interval = false
    },
    start(item){
      this.SelectedItem = item;
    	if(!this.interval){
      	this.interval = setInterval(() => this.SelectedItem.discount++, 30)	
      }
    },
    ShiftToSetTabl(item)
    {
      let vm = this;
      if(vm.SetTableItems.some(x=>x.id == item.id))
      {
        MSGHNDL.ERR("از هر محصول فقط یک تنوع میتواند در فروش ویژه قرار گیرد");
      }
      else
      {
        item.showDate = false;
        item.showTime1 = false;
        item.showTime2 = false;
        item.discountype = 1;
        vm.SetTableItems.push(item);
      }
    },

      ShowBoxProducts(secid,bid,{srp})
      {
        let vm = this;
        console.warn("Passed Item to show products : ",srp);
        vm.SetTableItems = [];
        debugger;
        if(srp.length > 0)
        {
          var datetimeisset = false;
          srp.forEach(item=>{
            var mdl = {};
            mdl.title = item.combine.product.p_Title;
            mdl.disptitle = item.title;
            // mdl.warranty = item.combine.warranty.w_Title;
            // mdl.color = item.combine.colorDetail.c_Title;
            mdl.price = item.combine.x_Price;
            mdl.discountype = item.discountType;
            mdl.discount = item.discount;
            // mdl.sdate = item.dateDomain.split(',');
            // mdl.stime = item.startTime;
            // mdl.etime = item.endTime;
            mdl.status = item.status;
            mdl.ShowInIndex = item.showInIndex;
            mdl.id = item.combineId;
            vm.SetTableItems.push(mdl);
            if(!datetimeisset)
              {
                vm.Dates = item.dateDomain.split(',');
                vm.StartTime = item.startTime;
                vm.EndTime = item.endTime;
                console.warn(vm.Dates,vm.StartTime,vm.EndTime);
                datetimeisset = true;
              }
          });
        }
        vm.SetBoxProductsDialog = true;
        vm.SetProductBoxId = secid;
        vm.BoxID = bid;
      },
      async LoadBoxs()
      {
        let vm = this;
        await axios.post(ApiUrl.LoadPromotionBox+'/6').then((res)=>{
          var data = res.data;
          if(data.status)
          {
            for(var i in vm.BoxTableItems)
            {
              var find = data.data.findIndex(_item => _item.b_SectionId === vm.BoxTableItems[i].sectionId);
              if(find != -1)
              {
                
                var ritem = data.data[find];
                var litem = vm.BoxTableItems[i];
                console.warn(ritem );
                litem.title = ritem.b_Title;
                litem.type = ritem.b_LoadType ;
                litem.link = ritem.b_Link;
                litem.image = ritem.b_Image;
                vm.boxImage = ritem.b_Image;
                litem.color = ritem.b_ColorCode;
                litem.seo = ritem.b_Seo;
                litem.id = ritem.b_Id;
                litem.srp = ritem.suprises;
              }
            }
          }
        }).catch((err)=>{
          console.error("ERROR IN LOADING BOX INFORMATION",err);
        });
      },
      async SaveBoxDetail()
      {
        var vm = this;
        var Model = {};
        Model.B_Title = vm.boxTitle;
        Model.B_Image = vm.boxImage;
        Model.B_Seo = JSON.stringify(vm.seo);
        Model.B_Link = vm.boxLink;
        Model.B_SectionId = vm.boxId;
        Model.B_ColorCode = vm.boxColor;
        Model.B_LoadType = vm.boxType ? 2:1;
        Model.B_Type = 6;
        await axios.post(ApiUrl.AddPromotionBox,Model).then(async (res)=>{
          var data = res.data;
          if(data.status)
          {
            MSGHNDL.OK(data.msg);
            await vm.LoadBoxs();
            vm.SetBoxDetailDialog = false;
          }
          else
          {
            MSGHNDL.ERR(data.msg);
          }

        }).catch((err)=>{console.error(err)});

      },
      SeoChanged(seo)
      {
        this.seo = seo;
      },
    SetBoxDetail(secid)
    {
        this.boxId = secid.sectionId;
        if(secid.type != null)
        {
          this.boxType = secid.type == 1 ? false:true;
        }
        else
        {
          this.boxType = false;
        }

        this.boxTitle = secid.title;
        this.boxLink = secid.link;
        this.boxColor = secid.color;
        this.boxImage = secid.image;
        this.SeoData = secid.seo == "" ? {} : JSON.parse(secid.seo);
        this.SetBoxDetailDialog = true;
    }, 
    async SetProdTableJumpToPage(page)
    {
      await this.loadProductsForSet(page);
    },
    async loadProductsForSet(page = 1) {
      let vm = this;
      var url = ApiUrl.LoadProductForBoxs +"/"+vm.CatId+"/0/"+page+"/"+vm.PageSizeSet;
      if(vm.SetProductsSearchByPName != null && vm.SetProductsSearchByPName != "")
      {
        url+="/"+vm.SetProductsSearchByPName;
      }
      if(vm.SetProductsSearchByPCode != null && vm.SetProductsSearchByPCode != "")
      {
        url+="/"+vm.SetProductsSearchByPCode;
      }
      await axios
        .post(
          url
        )
        .then(async (res) => {

          var data = res.data;
          console.warn(data);
          vm.SetAllProductTableItems = [];
          if (data.status) {
            console.error("PRODUCT LISSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSTTTTTTTT: ",data.data.products);
             vm.SetAllProductTableItems = data.data.products;
            vm.PageCountsSet = data.data.totalPages;
            vm.CurrentPageSet = data.data.currentPage;
            vm.RelationDataLoaded = true;
            console.warn("LOADING RELATION DATA",data.data);
             await vm.LoadSets();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async LoadSets()
    {
      let vm = this;
      var Model = {};
      Model.Id = vm.SetProductBoxId;
      await axios.post(ApiUrl.LoadPromotionBoxProds,Model)
      .then(res=>{
        var data = res.data;
        if(data.status)
        {
          console.warn("RELATIONSSSSSSSSSSSSSSSSS:",data.data);
          if(data.data.length > 0)
          {
            vm.SetTableItems = [];
            var datetimeisset = false;
            data.data.forEach(el => {
              var item = vm.SetAllProductTableItems.findIndex(i=>i.id == el.x_ProdId && i.wid == el.x_WarrantyId && i.cid == el.x_ColorId);
              if(item != -1)
              {
                var element = vm.SetAllProductTableItems[item];
              element.discount = el.x_DiscountedPrice;
              element.disptitle = el.x_ProdTitle;
              var hasValue = false;
              var sd = "";
              var ed = "";
              var stime = "";
              var etime = "";
              if(el.x_StartDate != "" && el.x_StartDate != null && el.x_EndDate != "" && el.x_EndDate != null)
              {
                sd = el.x_StartDate.split("T");
                ed = el.x_EndDate.split("T");
                var st = sd[1].split(":");
                var et = ed[1].split(":");
                st.pop();
                et.pop();
                stime = st.join(":");
                etime = et.join(":");
                hasValue = true;
              }
               
              
              element.status = el.x_Status;
              element.showDate = false;
              element.showTime1 = false;
              element.showinindex = el.x_ShowInIndex;
              element.discountype = el.x_DiscountType;
              vm.SetTableItems.push(element);
              }
            });
          }
        }
        else
        {
         MSGHNDL.ERR(data.msg);
        }
      })
      .catch(err=>{console.error(err);});
    },

    }
}
</script>